import { render, staticRenderFns } from "./FilterPager.vue?vue&type=template&id=33200460"
import script from "./FilterPager.vue?vue&type=script&lang=js"
export * from "./FilterPager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports